import "./LandingPage.css";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputField from "../FormParts/InputField";
import FormSubmitButton from "../FormParts/FormSubmitButton";
import { getRequest } from "../Services/ContrectBackendAPI";
import UserProfile from "../Context/UserProfile";
import MessageDisplay from "../CommonPages/MessageDisplay";
import OtherData from "../Context/OtherData";


const UpdateUserName = ({ setDisplayLogin }) => {
	const usrForm = useRef(null);
	const navigate = useNavigate();
	const [msg, setMsg] = useState("");
	const [msgType, setMsgType] = useState("");
	useEffect(() => {
		if (UserProfile.getLoginStatus() === "1") {
			navigate("/Home");
		}
	}, []);
	const handleSubmit = (e) => {
		e.preventDefault();
		if (!validateName()) {
			return;
		}
		var displayName=usrForm.current['userDisplayName'].value;
		getRequest("api/Auth/UpdateDisplayName?newName="+displayName, UserProfile.getToken()).then(r => r.json()).then(res => { 
			if (res.status===1){
				UserProfile.setName(displayName.toString());
				navigate("/Home");
    		}else{
				setMsg("Not able to update name. Try again later.");
				setMsgType("Error");
				return;
			}
		}).catch(err => {
			console.log(err);
		});

	};
	const validateName = () => {
		var displayName = usrForm.current['userDisplayName'].value ;
		let isnum = displayName.length >= 20 ? false : true;
		if (!isnum) {
			setMsg("User name cannot be more than 20 characters.");
			setMsgType("Error");
		}
		return isnum;
	}

	return (
		<>
			<MessageDisplay msgType={msgType} msg={msg} setMsg={setMsg} />
			<div className="login-container">

				<div className="login-header">
					<div className="logo">
						<a style={{ textDecoration: "none" }} href="/">
							<span style={{ color: 'white' }}>Contr
								<span style={{ color: "#ff8400" }}>e</span>
								ct</span>
						</a>
					</div>
					<h1>You are a first time user.</h1>
					<p>Please tell us your name for contract drafting purposes.</p>
				</div>


				<div className="login-form">

					<Form ref={usrForm} onSubmit={handleSubmit} >

						<div className="form-content" id="phone-form" >
							<div className="otp-section">
								<div className="form-group">
									<label>Legal name (used in contract)</label>
									<div className="otp-inputs">
										<input type="text" className="otp-input"  name="userDisplayName"  inputmode="text" />
									</div>
								</div>
								<button type="button" className="btn btn-secondary" onClick={(e)=>{
									e.preventDefault();
									navigate("/Home");
								}}>Skip</button>
								<button type="submit" className="btn btn-primary">Save & continue</button>
							</div>
						</div>
					</Form>
				</div>
			</div>
			
		</>
	);
};

export default UpdateUserName;